/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/hooks/useLessonQuizMeFromCache.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { isAcceptanceTest } from 'hub-http/helpers/env';
import { useMemo, useRef } from 'react';
import { useAsyncBulkGetQuizMeQuery } from '../../../../__generated__/chirp/com/hubspot/academy/gen/ai/skills/rpc/QuizMeRpc.hooks';
import { buildLessonDifficultyTaskIds, selectPollTaskByTaskId, useQuizMeSession } from '../utils/quizMeUtils.migrated';
import { shuffleTaskAnswers } from '../utils/contentUtils.migrated';
import { useLessonQuizMeVideoRequestParams } from './useLessonQuizMe.migrated';
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/hooks/useLessonQuizMeFromCache.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useLessonQuizMeFromCache = ({
  contents,
  lessonContentId,
  selectedDifficulty
}) => {
  const shuffledCacheRef = useRef({
    correlationId: undefined,
    result: undefined
  });
  const {
    getQuizState
  } = useQuizMeSession();
  const {
    requestParams
  } = useLessonQuizMeVideoRequestParams({
    contents
  });
  const contentIds = useMemo(() => {
    var _requestParams$map$fi;
    return (_requestParams$map$fi = requestParams === null || requestParams === void 0 ? void 0 : requestParams.map(({
      lessonContentId: id
    }) => id).filter(id => id !== undefined)) !== null && _requestParams$map$fi !== void 0 ? _requestParams$map$fi : [];
  }, [requestParams]);
  const taskIds = useMemo(() => contentIds.length === 0 ? [] : buildLessonDifficultyTaskIds(contentIds, id => getQuizState(id, 'LESSON')), [contentIds, getQuizState]);
  const {
    data
  } = useAsyncBulkGetQuizMeQuery({
    fetchPolicy: 'cache-only',
    variables: {
      taskIds
    },
    skip: isAcceptanceTest() || taskIds.length === 0
  });
  const quizMeData = useMemo(() => {
    var _state$difficultyTask, _task$quizResponse;
    const state = lessonContentId ? getQuizState(lessonContentId, 'LESSON') : undefined;
    const contentTaskId = selectedDifficulty ? state === null || state === void 0 || (_state$difficultyTask = state.difficultyTasks) === null || _state$difficultyTask === void 0 ? void 0 : _state$difficultyTask[selectedDifficulty] : undefined;
    const task = selectPollTaskByTaskId(data === null || data === void 0 ? void 0 : data.tasks, contentTaskId);
    const correlationId = task === null || task === void 0 || (_task$quizResponse = task.quizResponse) === null || _task$quizResponse === void 0 ? void 0 : _task$quizResponse.correlationId;
    const cached = shuffledCacheRef.current;
    if (!correlationId) {
      return task;
    }
    if (correlationId === cached.correlationId) {
      return cached.result;
    }
    const shuffled = shuffleTaskAnswers(task);
    shuffledCacheRef.current = {
      correlationId,
      result: shuffled
    };
    return shuffled;
  }, [data, lessonContentId, getQuizState, selectedDifficulty]);
  return quizMeData;
};